<template>
    <div class="online-serve">
        <!-- class="iconfont img_transform_area" -->

        <template v-for="(item,index) in webInfo.onlineServe">
            <el-popover placement="left-start" :width="item.width" trigger="hover" :key="index"
                :disabled="item.disabled">

                <div class="popover">
                    <span v-if="item.text == '电话咨询'">
                        <span>电话：{{webInfo.mobile}}</span><br>
                    </span>

                    <img v-if="item.popoverUrl" :src="item.popoverUrl" alt="二维码" style="width:125px" />
                </div>

                <div slot="reference">
                    <div :class="['item' , 'border']" @click="myclick(item)">
                        <div class="img-box" v-if="item.imgUrl">
                            <img :src="item.imgUrl" alt="">
                        </div>
                        <p class="text">{{item.text}}</p>
                    </div>
                </div>
            </el-popover>
        </template>

        <div class="last-box">
            <el-button type="primary" @click="tryHandler()">立即体验</el-button>
        </div>

    </div>
</template>

<script>
export default {
    
    computed: {},
    watch: {},
    data () {
        return {

        };
    },
    methods: {
        // 立即体验 ，产品预约
        tryHandler () {
            this.$store.commit('global-dialog/updateDialogVisible', {
                name: 'reservation',
                visible: true,
            });
        },

        myclick (item) {
            if (item.itemCilck) {
                this[item.itemCilck]();
            }
        },
    },
    mounted: function () { },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/hzc.scss';

.online-serve {
    position: fixed;
    top: 58%;
    right: 8px;
    transform: translate(0px, -50%);
    z-index: 999;
    line-height: normal;
    background: white;
    border: 1px solid #dcdfe6;

    .item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 70px;
        height: 70px;
        cursor: pointer;
        transition: all 0.3s;

        &.border {
            border-top: 1px solid #dcdfe6;
        }

        &:hover {
            background: #eee;
        }

        &:last-child :hover {
            background: none;
        }

        // .iconfont {
        //     font-size: 28px;
        //     font-weight: normal;
        // }
        .img-box {
            width: 32px;
            height: 32px;
            img {
                width: 32px;
            }
        }

        .text {
            line-height: 1em;
            margin-top: 4px;
        }
    }

    .last-box {
        ::v-deep .el-button {
            width: 70px;
            height: 50px;
            padding: 0;
            border-radius: 0;
        }
        cursor: pointer;
        transition: all 0.3s;
    }

    .img_transform_area {
        animation: rotate 2s infinite;
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    20% {
        transform: rotate(25deg);
    }
    40% {
        transform: rotate(-23deg);
    }
    60% {
        transform: rotate(20deg);
    }
    80% {
        transform: rotate(-13deg);
    }
    100% {
        transform: rotate(3deg);
    }
}
</style>